/*
 * /TS/INTERNAL/CODE/CONFIDENTIAL
 * File: index.js
 * Project: parcel-react-tailwindcss-template
 * File Created: Sunday, 16th May 2021 1:37:07 pm
 * Author: Mark Kennard (mark.kennard@threatstatus.com)
 * -----
 * Last Modified: Sunday, 16th May 2021 1:37:07 pm
 * Modified By: Mark Kennard (mark.kennard@threatstatus.com>)
 * -----
 * Copyright 2018 - 2021 Threat Status Limited
 */
import React from 'react'

export default function HorizontalRule() {
  return (
    <div className="mx-auto  w-3/5 pt-3 mt-4 border-b-2 border-snowmeister-400 opacity-25"></div>
  )
}
